import { Injectable } from '@angular/core';
import { EmployeesService } from 'src/api';
import { EmployeesStore } from './state/employees.store';
import { BehaviorSubject, firstValueFrom, map, Observable } from 'rxjs';
import { EmployeesQuery } from './state/employees.query';

@Injectable({
  providedIn: 'root',
})
export class EmployeesRepository {
  private employeeRoleSubject = new BehaviorSubject<string | null | undefined>(null);
  
  constructor(
    private employeesService: EmployeesService,
    private employeesStore: EmployeesStore,
    private employeesQuery: EmployeesQuery
  ) {}

  loadEmployees = async () => {
    if (!this.employeesQuery.getHasCache()) {
      const employees = await firstValueFrom(this.employeesService.getVEmployees1('1'));

      this.employeesStore.set(employees);
    }
  };

  getEmployee = async (id: number) => {
    const employee = await firstValueFrom(this.employeesService.getVEmployees(id, '1'));

    this.employeesStore.upsert(id, employee);
  };

  getLoggedInEmployee = async () => {
    if (!this.employeesQuery.getHasCache()) {
      const employee = await firstValueFrom(this.employeesService.getVEmployeesMe('1'));

      this.employeesStore.set([employee]);
    }
  };

  updateSearchTerm(searchTerm?: string) {
    this.employeesStore.update((s: { filters: any }) => ({
      filters: { ...s.filters, searchTerm: searchTerm },
    }));
  }

  getLoggedInEmployeeRole(): Observable<string | null | undefined> {
    if (!this.employeeRoleSubject.getValue()) {
      this.employeesService.getVEmployeesMe('1').pipe(
        map((employee) => employee.role)
      ).subscribe((role) => {
        this.employeeRoleSubject.next(role);
      });
    }
    return this.employeeRoleSubject.asObservable();
  }
}
